export default "/public/img/logoRightDe-87cbcf711218bc211def9fe21b827065.png";